import { useCallback } from 'react';
import { UserAttribute, UserAttributeSource } from '../../models/UserAttribute';
import { useHttpFetchApi } from '../http/useHttpFetch';

export function useFindLatestAttributes() {
  const { loading, error, postJson } = useHttpFetchApi();

  const findLatestAttributes = useCallback(
    (
      userId: number,
      sources: UserAttributeSource[],
      startDate?: string,
      endDate?: string
    ) => {
      return postJson<UserAttribute[]>(`users/${userId}/attributes/latest`, {
        sources,
        timeZoneOffset: new Date().getTimezoneOffset(),
        startDate,
        endDate
      });
    },
    [postJson]
  );

  return {
    loadingLatestAttributes: loading,
    userAttributesError: error,
    findLatestAttributes
  };
}
